// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2kGcH","fileBtn":"File_fileBtn__fiRfs","closeBtn":"File_closeBtn__NIg80","fileSelected":"File_fileSelected__3Oy31","disabled":"File_disabled__3WNNR"};